<template>
  <div style="padding:100px">
	  <Tableau
	    url="https://tableau.123goecom.com/javascripts/api/viz_v1.js"
	    ref="tableau"
	    width:1000
	    height:1000
    />
  </div>
</template>


<script>
import 'vue-tableau';
export default {
    components:{},
  data() {
    return {
      msg: "Hello Tableau Fans!",
      url: "https://tableau.123goecom.com/#/signin?closePopupWhenDone=true&site=&authSetting=DEFAULT&siteLuid=&embedded=true"
    };
  },
  mounted() {
  },
  methods: {
  },
};
</script>

<style>
</style>
